'use client';

import { useSession } from '@shared/auth';
import { isAccountSuspendedStatus } from '../utils/isAccountSuspendedStatus';

function useIsAccountSuspended() {
  const { session } = useSession();
  return isAccountSuspendedStatus(session?.profile?.status);
}

export { useIsAccountSuspended };
